const pxToRem = (px: number, base = 16) => `${px / base}rem`;

export const screens = {
    'phone': pxToRem(0),
    'tablet': pxToRem(490),
    'tablet-wide': pxToRem(768),
    'desk-small': pxToRem(1000),
    'desk': pxToRem(1200),
    'big-desk': pxToRem(1400),
};

